/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const ContentIssueEnum = {
    MISSING_ARTICLE: 'missing_article',
    MISSING_DESCRIPTION: 'missing_description',
    MISSING_IMAGE: 'missing_image',
    MISSING_MANUFACTURER_INFO: 'missing_manufacturer_info'
};
